import pdfMake, { userMark, setMyConfig, makeTableContent } from "../utils/pdf";

function pdfEndoseLiquidacion(pContent) {
  const columns = [
    "fecha:wauto",
    {
      key: "codigo",
      label: "Código",
      width: "auto",
    },
    "file:wauto",
    "servicio:w*",
    "hotel:w*",
    {
      key: "servicioTipo",
      label: "Tipo",
      width: "auto",
    },
    {
      key: "nroAdultos",
      label: "PAX",
      width: "auto",
    },
    {
      key: "nroNinos",
      label: "CHD",
      width: "auto",
    },
    {
      key: "moneda",
      label: "Moneda",
      width: "auto",
    },
    {
      key: "tarifa",
      label: "Monto",
      width: 50,
    },
    "observaciones:w*",
  ];

  const table = makeTableContent([...pContent.items], columns);

  const liquidacion = pContent.header.masDeUnaMoneda ? pContent.header.liquidaciones.map((item) => ({ text: `Cód. Liquidación ${item.moneda}: ${item.codigo}`, width: "auto" })) : [{ text: `Cód. Liquidación: ${pContent.header.codigoLiquidacion || ""}`, width: "auto" }];

  liquidacion.push({
    text: `Fecha Liquidación: ${pContent.header.fechaLiquidacion}`,
    width: "auto",
  });

  pdfMake
    .createPdf({
      info: {
        title: `Endose Liquidación` + (pContent.preview ? " (Previsualización)" : ""),
      },
      content: [
        {
          text: "Endose Liquidación" + (pContent.preview ? " (Previsualización)" : ""),
          style: "h1",
        },
        {
          columns: [
            {
              text: `Agencia: ${pContent.header.agencia}`,
              width: "auto",
            },
            {
              text: `Pasajero: ${pContent.header.pasajero}`,
              width: "auto",
            },
            ...(pContent.preview == false ? liquidacion : []),
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfEndoseLiquidacion;
